// extracted by mini-css-extract-plugin
module.exports = {"content":"guide-modal_content__2X7je","description":"guide-modal_description__OwHLr","modal":"guide-modal_modal__3yTKn","customModal":"guide-modal_customModal__11KYo"};